import React from 'react'
import { Stack, Typography } from '@mui/material'
import { OrgRole, type OrgMemberRow } from 'pure-js/types/OrganizationMembership'

import { Button } from '../../../../interaxDesignSystemComponents'
import { DefaultModal } from '../../../../shared/components/DefaultModal'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { TESTIDS } from '../../../../config/testids'
import { LeaderLossWarning } from './LeaderLossWarning'

interface RemoveMemberConfirmModalProps {
  target: OrgMemberRow | null
  onClose: () => void
  onConfirm: () => void
  isPending: boolean
}

export const RemoveMemberConfirmModal: React.FC<RemoveMemberConfirmModalProps> = ({
  target,
  onClose,
  onConfirm,
  isPending
}) => {
  const { t } = useTranslation()
  const memberLabel = target?.displayName || target?.email || target?.userId

  return (
    <DefaultModal isOpen={target !== null} onClose={onClose} maxWidth="420px">
      <Stack spacing={2.5}>
        <Typography sx={{ fontSize: '20px', fontWeight: 600, color: INTERAX_COLORS.white }}>
          {t('org.members.removeTitle')}
        </Typography>
        {target && (
          <Typography sx={{ fontSize: '14px', color: INTERAX_COLORS.white70, lineHeight: 1.5 }}>
            {t('org.members.removeBody', { name: memberLabel })}
          </Typography>
        )}
        {target?.role === OrgRole.LEADER && (
          <LeaderLossWarning
            body={t('org.members.leaderRemovalWarningBody', { name: memberLabel })}
            testId={TESTIDS.ORG_LEADER_REMOVAL_WARNING}
          />
        )}
        <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
          <Button variant="secondary" size="small" onClick={onClose}>
            {t('org.members.invite.cancel')}
          </Button>
          <Button variant="primary" size="small" onClick={onConfirm} disabled={isPending}>
            {t('org.members.removeConfirm')}
          </Button>
        </Stack>
      </Stack>
    </DefaultModal>
  )
}
